import Angular from "angular";
import Controller from "./chart-booking-progress.controller";
import Template from "./chart-booking-progress.html";

export default Angular.module('chart-booking-progress', [])
    .component('chartBookingProgress', {
        template: Template,
        controller: Controller,
        bindings: {
            bookings: '<'
        },
    })



// WEBPACK FOOTER //
// ./src/modules/main/components/chart-booking-progress/chart-booking-progress.js